module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-5@2x__a8dc1985756a390fc83a6ebdaea42552.png";